import React from 'react';
import { useTranslation } from 'react-i18next';
import { Notice } from './Notice';
import AlertTriangle from '../../icons/yellow-triangle.svg';

type ModificationNoticeProps = {
	variant: 'seatingChange' | 'priceChange' | null;
};

export const ModificationNotice = ({ variant }: ModificationNoticeProps) => {
	const { t } = useTranslation();

	const body: Record<typeof variant, React.ReactNode> = {
		seatingChange: (
			<p>
				{t('notices.seating_change_modification')}
			</p>
		),
		priceChange: <p>{t('notices.price_change_modification')}</p>
	};

	const icon: Record<typeof variant, React.ReactNode> = {
		seatingChange: <img src={AlertTriangle} alt={t('aria.view_seating_options')} style={{ width: '24px', height: '24px' }} />,
		priceChange: <img src={AlertTriangle} alt={t('aria.review_required')} style={{ width: '24px', height: '24px' }} />
	};

	if (!variant) {
		return null;
	}

	return <Notice body={body[variant]} icon={icon[variant]} />;
};
